import { render } from "./list.vue?vue&type=template&id=969efec0&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=969efec0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\work\\zhongsheng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-969efec0"]])

export default __exports__